import { METHOD } from './method'

export const API_SEARCH_PAGE = {
    DETAIL: {
        api: '/v1/dashboard-admin/general-setting/search',
        method: METHOD.GET,
    },
    BRAND_LIST: {
        api: '/v1/dashboard-admin/general-setting/list-brand',
        method: METHOD.GET,
    },
    PRODUCT_LIST: {
        api: '/v1/dashboard-admin/general-setting/list-product',
        method: METHOD.GET,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/general-setting/search',
        method: METHOD.PUT,
    },
}
